import { render, staticRenderFns } from "./ScientificProduction.vue?vue&type=template&id=46a1c1d2"
import script from "./ScientificProduction.vue?vue&type=script&lang=js"
export * from "./ScientificProduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports